(() => {
 'use strict';
 const motionAllowed=()=>!matchMedia('(prefers-reduced-motion:reduce)').matches&&document.documentElement.dataset.motion!=='false'&&document.documentElement.dataset.lowPerformance!=='true';
 if(!customElements.get('rlth-material-guide'))customElements.define('rlth-material-guide',class extends HTMLElement{
  connectedCallback(){
   if(this.controller)return;
   this.controller=new AbortController();const signal=this.controller.signal;
   const buttons=[...this.querySelectorAll('[data-material]')],photo=this.querySelector('[data-material-image]');
   buttons.forEach((button,i)=>button.addEventListener('click',()=>{
    buttons.forEach(b=>b.setAttribute('aria-pressed',String(b===button)));
    photo.src=button.dataset.image;photo.alt='Illustrative '+button.dataset.material.toLowerCase()+' texture';
    this.querySelector('[data-material-index]').textContent=String(i+1).padStart(2,'0')+' / 04';
    this.querySelector('[data-material-detail]').textContent=button.dataset.detail;
    this.animation?.cancel();
    if(motionAllowed()&&photo.animate)this.animation=photo.animate([{transform:'scale(1.06)',opacity:.55},{transform:'scale(1)',opacity:1}],{duration:350,easing:'ease-out'});
   },{signal}));
  }
  disconnectedCallback(){this.controller?.abort();this.controller=null;this.animation?.cancel();}
 });
 if(!customElements.get('rlth-mobile-chart'))customElements.define('rlth-mobile-chart',class extends HTMLElement{
  connectedCallback(){
   if(this.controller)return;
   this.controller=new AbortController();const signal=this.controller.signal;
   this.lab=this.closest('rlth-lab');if(!this.lab)return;
   this.mobile=matchMedia('(max-width:899px)');
   this.redraw=()=>{if(this.mobile.matches)this.draw();};
   this.lab.addEventListener('rlth:lab:draw',this.redraw,{signal});
   this.mobile.addEventListener('change',()=>{if(this.mobile.matches)this.draw();else this.lab.draw?.();},{signal});
   this.observer=new ResizeObserver(this.redraw);this.observer.observe(this);this.redraw();
  }
  draw(){
   const data=this.lab.data||JSON.parse(this.lab.querySelector('[data-lab-dataset]').textContent);
   const metric=this.lab.metric||'ei',all=this.lab.enabled||new Set(data.map(d=>d.id));
   const rows=data.filter(d=>all.has(d.id));
   const width=Math.max(260,this.clientWidth),height=rows.length*86+64,max=metric==='ei'?60:14;
   const ns='http://www.w3.org/2000/svg';
   const make=(tag,attrs,text)=>{const el=document.createElementNS(ns,tag);for(const[k,v]of Object.entries(attrs))el.setAttribute(k,String(v));if(text!==undefined)el.textContent=text;return el;};
   const svg=make('svg',{viewBox:'0 0 '+width+' '+height,role:'img','aria-label':(metric==='ei'?'EI per millimetre':'Torsional stiffness')+' comparison on a fixed scale. '+rows.map(d=>d.name+': '+(d[metric]===null?'not supplied':d[metric])).join('; ')});
   svg.append(make('title',{},metric==='ei'?'Bending stiffness per millimetre':'Torsion relative to Maple'));
   rows.forEach((d,i)=>{
    const y=i*86+22,value=d[metric],label=d.name.replace('Standard 7-ply Maple','7-ply Maple');
    const words=label.split(' ');let first='',second='';
    for(const word of words){if(!second&&(first+' '+word).length<(width-94)/7)first+=(first?' ':'')+word;else second+=(second?' ':'')+word;}
    svg.append(make('text',{x:18,y,'font-size':13},first));
    if(second)svg.append(make('text',{x:18,y:y+16,'font-size':13},second));
    svg.append(make('text',{x:width-18,y,'font-size':14,'text-anchor':'end'},value===null?'—':metric==='ei'?value.toFixed(1):value+'×'));
    const trackY=y+30;
    svg.append(make('rect',{x:18,y:trackY,width:width-36,height:10,fill:'#2d3748'}));
    if(value!==null)svg.append(make('rect',{x:18,y:trackY,width:Math.max(0,Math.min(max,value))/max*(width-36),height:10,fill:d.color}));
    else svg.append(make('text',{x:18,y:trackY+28,'font-size':11},'Measurement not supplied'));
   });
   const ticks=metric==='ei'?[0,15,30,45,60]:[0,3.5,7,10.5,14];
   ticks.forEach((tick,i)=>svg.append(make('text',{x:18+(width-36)*i/4,y:height-24,'font-size':11,'text-anchor':i===0?'start':i===4?'end':'middle'},tick)));
   this.replaceChildren(svg);
   const readout=this.lab.querySelector('[data-lab-readout]');
   if(readout)readout.textContent=rows.length?rows.length+' constructions shown. Every bar uses the same '+(metric==='ei'?'0–60 EI/mm scale.':'0–14 torsion scale.'):'Choose at least one construction above.';
  }
  disconnectedCallback(){this.controller?.abort();this.observer?.disconnect();this.controller=null;}
 });
 if(!customElements.get('rlth-buy-dock'))customElements.define('rlth-buy-dock',class extends HTMLElement{
  connectedCallback(){
   if(this.controller)return;
   this.controller=new AbortController();const signal=this.controller.signal;
   const product=this.closest('product-detail'),form=product?.querySelector('[data-product-form]');if(!form)return;
   const button=this.querySelector('button'),source=product.querySelector('[data-product-price]'),price=this.querySelector('[data-dock-price]');
   const syncPrice=()=>{if(source&&price)price.textContent=source.textContent.trim();};syncPrice();
   this.priceObserver=new MutationObserver(syncPrice);if(source)this.priceObserver.observe(source,{childList:true,characterData:true,subtree:true});
   button.addEventListener('click',()=>{form.scrollIntoView({block:'center',behavior:motionAllowed()?'smooth':'instant'});form.querySelector('select')?.focus({preventScroll:true});},{signal});
   const purchase=form.querySelector('button[type=submit]');
   this.observer=new IntersectionObserver(entries=>{this.hidden=entries[0].isIntersecting;},{threshold:.2});if(purchase)this.observer.observe(purchase);
   this.hidden=false;
  }
  disconnectedCallback(){this.controller?.abort();this.priceObserver?.disconnect();this.observer?.disconnect();this.controller=null;}
 });
})();
